module.exports = __webpack_public_path__ + "img/copy-all.ec112e0d.svg";